import {AbstractDataApiPlugin, PluginSettings} from './abstract-data-api-plugin';

/**
 * Base for a latest plugin.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export abstract class AbstractLatest<T extends any, S extends PluginSettings> extends AbstractDataApiPlugin<S> {
  constructor(container: HTMLElement) {
    super(container);
  }
}
